import React, { useContext } from 'react';
import cn from 'classnames';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { ResponsiveContext } from '../../ResponsiveContext.js';
import { l as layoutStyles } from '../../layout.module-a1fa9754.js';

var styles = {"component":"modal__component_1ds60"};
require('./index.css')

var Controls = function (_a) {
    var primary = _a.primary, secondary = _a.secondary, gap = _a.gap, _b = _a.layout, layoutProp = _b === void 0 ? 'start' : _b, _c = _a.mobileLayout, mobileLayout = _c === void 0 ? layoutProp : _c;
    var _d = useContext(ResponsiveContext), view = _d.view, dataTestId = _d.dataTestId;
    var layout = view === 'mobile' ? mobileLayout : layoutProp;
    var shouldReverse = view === 'mobile' && layout !== 'column';
    return (React.createElement("div", { "data-test-id": getDataTestId(dataTestId, 'controls'), className: cn(styles.component, layoutStyles[layout], gap && layoutStyles["gap-".concat(gap)]) }, shouldReverse ? (React.createElement(React.Fragment, null,
        secondary,
        primary)) : (React.createElement(React.Fragment, null,
        primary,
        secondary))));
};

export { Controls };
